module.exports = __webpack_public_path__ + "img/liveNum7.6afa530f.png";